import React, { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks/hooks";
import Result from "../../components/common/Result";


const ResultsSection: React.FC = () => {
	const results = useAppSelector(state => state.pressureDropCalculator.results);
	const { i18n, t } = useTranslation();
	return (
		<fieldset className="pressure-drop__result-block round-corner-container">
			<legend>{t('common:results_title')}</legend>
			<div className="pressure-drop__results" aria-label={t('common:results_title')}>
				<div className="pressure-drop__results-column-names">
					<span title={t("pressure_drop:result_titles.gas_rate")}><Trans ns="pressure_drop" i18nKey="result_columns.gas_rate" components={{ sub: <sub /> }} /></span>
					<span title={t("pressure_drop:result_titles.pressure_wh")}><Trans ns="pressure_drop" i18nKey="result_columns.pressure_wh" components={{ sub: <sub /> }} /></span>
					<span title={t("pressure_drop:result_titles.pressure_drop")}><Trans ns="pressure_drop" i18nKey="result_columns.pressure_drop" components={{ sub: <sub /> }} /></span>
					<span title={t("pressure_drop:result_titles.pressure_gradient")}><Trans ns="pressure_drop" i18nKey="result_columns.pressure_gradient" components={{ sub: <sub /> }} /></span>
					<span title={t("pressure_drop:result_titles.maximum_velocity")}><Trans ns="pressure_drop" i18nKey="result_columns.maximum_velocity" components={{ sub: <sub /> }} /></span>
				</div>
				<div className="pressure-drop__results-column-units">
					<span className="unit-font-size">
						<Trans
							ns={'pressure_drop'}
							key={i18n.language}
							i18nKey={t(`common:measurement_units.q.mln_m3_day`)}
							style={{ fontSize: '7px' }}
							components={{
								sub: <sub />,
								sup: <sup />,
							}}
						/>
					</span>
					<span className="unit-font-size">
						{t(`common:measurement_units.pressure.bar`)}
					</span>
					<span className="unit-font-size">
						{t(`common:measurement_units.pressure.bar`)}
					</span>
					<span className="unit-font-size">
						{t(`common:measurement_units.result.barkm`)}
					</span>
					<span className="unit-font-size">
						{t(`common:measurement_units.result.ms`)}
					</span>
				</div>
				{results.gasRate.map((value, index) => {
					return (
						<div className="pressure-drop__result-row result-row" key={index}>
							<Result
								id={`gasRate_${index}`}
								value={value?.toString()}
							/>
							<Result
								id={`pressureWh_${index}`}
								value={results.pressureWh[index]?.toString()}
							/>
							<Result
								id={`pressureDrop_${index}`}
								value={results.pressureDrop[index]?.toString()}
							/>
							<Result
								id={`pressureGradient_${index}`}
								value={results.pressureGradient[index]?.toString()}
							/>
							<Result
								id={`maximumVelocity_${index}`}
								value={results.maximumVelocity[index]?.toString()}
								className={results.maximumVelocity[index] > 20 ? "highlight" : ""}
							/>
						</div>
					);
				})}
			</div>
		</fieldset>
	);
};

export default memo(ResultsSection);
